import { TAuthority } from './authority.types';

/**========================================================================
 **                            Search providers
 *========================================================================**/

export interface ISearchedProvider {
  id: string;
  companyInfo: CompanyInfo;
  personInfo: null;
  address: Address;
  name: string;
  contactEmail: string;
  contactPhone: string;
  iban: string;
  webUrl: null;
  logoUrl: null;
  medicalProvider: boolean;
  status: TProviderStatus;
  guarantor: IGuarantor | null;
}

export interface Address {
  address: string;
  city: string;
  postCode: string;
  country: string;
}

export interface CompanyInfo {
  identificationNumber: string;
  taxIdentificationNumber: string;
  valueAddedTaxIdentificationNumber: string;
}

export type TProviderSearchParams = {
  page?: number;
  pageSize?: number;
  sortBy?: 'createdAt';
  direction?: 'ASC' | 'DESC';
  name?: string;
};

export interface IGuarantor {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  doctorCode: string;
}

/**========================================================================
 **                          Get user providers
 *========================================================================**/

export const providerStatusesTypes = [
  'pending',
  'pendingWithGuarator',
  'approved',
  'rejected',
] as const;
export type TProviderStatus = typeof providerStatusesTypes[number];

export const paringStatusesTypes = [
  'invited',
  'pending',
  'approved',
  'rejected',
  'changed',
] as const;
export const paringStatusesList = Array.from(paringStatusesTypes);
export type TPairingStatus = typeof paringStatusesTypes[number];

export interface IUserProviderItem {
  provider: Provider;
  role: IUserProviderRole;
  status: TPairingStatus;
  createdAt: string;
  timeline: IPairingTimeline[];
}

export interface IPairingTimeline {
  status: TPairingStatus;
  userId: string;
  adminId: null;
  note: null | string;
  createdAt: string;
}

export interface Provider {
  id: string;
  companyInfo: CompanyInfo;
  personInfo: null;
  address: Address;
  name: string;
  contactEmail: string;
  contactPhone: string;
  iban: string;
  webUrl: string | null;
  logoUrl: string | null;
  medicalProvider: boolean;
  status: TProviderStatus;
  guarantor: IGuarantor;
}

export interface IUserProviderRole {
  id: string;
  name: string;
  permission: TAuthority[];
}

/**========================================================================
 **                            Create providers
 *========================================================================**/

export interface CreateProviderParams {
  name: string;
  address: string;
  city: string;
  postCode: string;
  country: string;
  contactEmail: string;
  contactPhone: string;
  iban: string;
  identificationNumber: string;
  taxIdentificationNumber: string;
  valueAddedTaxIdentificationNumber: string;
  webUrl: string | null;
}
